// This pattern inspired by
// https://stackoverflow.com/questions/31089801/extending-error-in-javascript-with-es6-syntax-babel
class ExtendableError extends Error {
	constructor(message) {
		// noinspection JSCheckFunctionSignatures
		super(message);
		this.name = this.constructor.name;
		if ('function' === typeof Error.captureStackTrace){
			Error.captureStackTrace(this, this.constructor)
		} else {
			this.stack = (new Error(message)).stack;
		}
	}
}

export class ConnectionError extends ExtendableError {
	constructor(message) {
		super(message);
	}
}

export class AppError extends ExtendableError {
	constructor(object) {
		super(object.message);
		this.object = object;
	}
	
	get title() {
		return this.object.title;
	}
}